import { render } from "./ProjetPage.vue?vue&type=template&id=63adfe22&scoped=true"
import script from "./ProjetPage.vue?vue&type=script&lang=js"
export * from "./ProjetPage.vue?vue&type=script&lang=js"

import "./ProjetPage.vue?vue&type=style&index=0&id=63adfe22&lang=scss&scoped=true"

import exportComponent from "/home/maud/code/ixperya2.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63adfe22"]])

export default __exports__